import React from "react";
import styled, { keyframes } from "styled-components";

const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(20px); }
  to { opacity: 1; transform: translateY(0); }
`;

const CoverContainer = styled.section`
  height: 100vh;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  position: relative;
  overflow: hidden;
  /* Fondo con gradiente y overlay oscuro para que el texto resalte */
  background: linear-gradient(rgba(15, 23, 42, 0.8), rgba(15, 23, 42, 0.8)), 
              url('https://images.unsplash.com/photo-1451187580459-43490279c0fa?q=80&w=2072&auto=format&fit=crop');
  background-size: cover;
  background-position: center;
  color: #ffffff;
  padding: 0 20px;

  @media screen and (max-width: 760px) {
    height: 80vh; /* Un poco más alto para que luzca el diseño */
  }
`;

const Badge = styled.span`
  background: rgba(59, 130, 246, 0.2);
  color: #3b82f6;
  padding: 8px 16px;
  border-radius: 50px;
  font-size: 0.9rem;
  font-weight: 600;
  margin-bottom: 20px;
  border: 1px solid rgba(59, 130, 246, 0.3);
  animation: ${fadeIn} 0.6s ease-out;
`;

const MainTitle = styled.h1`
  font-size: clamp(2.5rem, 8vw, 4.5rem); /* Tamaño fluido según pantalla */
  font-weight: 800;
  line-height: 1.1;
  max-width: 900px;
  margin-bottom: 20px;
  background: linear-gradient(to right, #fff, #94a3b8);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  animation: ${fadeIn} 0.8s ease-out;

  @media screen and (max-width: 760px) {
    font-size: 2.2rem;
  }
`;

const Highlight = styled.span`
  color: #3b82f6;
  -webkit-text-fill-color: #3b82f6;
`;

const Subtitle = styled.p`
  font-size: clamp(1rem, 4vw, 1.25rem);
  color: #94a3b8;
  max-width: 650px;
  margin-bottom: 40px;
  line-height: 1.6;
  animation: ${fadeIn} 1s ease-out;
`;

const PriceTag = styled.div`
  background: #f59e0b; /* Color ámbar/oro para llamar la atención */
  color: #000;
  padding: 10px 20px;
  font-weight: 700;
  border-radius: 4px;
  font-size: 1.1rem;
  transform: rotate(-2deg);
  box-shadow: 0 10px 20px rgba(0,0,0,0.2);
  margin-bottom: 40px;
  animation: ${fadeIn} 1.2s ease-out;

  @media screen and (max-width: 760px) {
    font-size: 0.9rem;
  }
`;

const Cover = () => {
  return (
    <CoverContainer>
      <Badge>DANY WEB • Agencia Digital</Badge>
      
      <MainTitle>
        Impulsá tu negocio con un <Highlight>Diseño Web</Highlight> de alto impacto.
      </MainTitle>

      <Subtitle>
        Creamos Landing Pages, E-commerce y Sitios Profesionales 
        diseñados para convertir visitantes en clientes.
      </Subtitle>

      <PriceTag>
        🚀 ¡Descuentos exclusivos este mes!
      </PriceTag>
    </CoverContainer>
  );
};

export default Cover;